import { useTranslation } from 'react-i18next';

import {
  copyLink,
  formatUSD,
  showNetworkType,
  showTokenType,
  USDT
} from '../../helpers/helperFunctions';

import { useHistory } from 'react-router-dom';

import { useAppSelector } from '../../app/hooks';
import { ORDERS } from '../../routes/routes';
import { P3 } from '../../styles/FontStyles';
import { Button } from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';
import { Icon, IconCopy } from '../../styles/Icons';
import { SelectedUSDT } from '../Marketplace/Marketplace.styled';

export const PaymentSuccess = ({
  selectedHub,
  selected,
  selectedToken
}: {
  selectedHub?: number;
  selected: any;
  selectedToken: any;
}) => {
  const { t } = useTranslation('packages');
  const history = useHistory();

  const { licence } = useAppSelector((state) => state.settings);
  const { userPackage } = useAppSelector((state) => state.marketplace);

  return (
    <>
      <P3 mb='8' color={color.colors.neutral900}>
        {t('success.text1')}
        <br />
        <br />
        {t('success.text2')}
        <br />
        <br />
        {t('success.text3')}
      </P3>

      <br />

      <div style={{ marginBottom: 20 }}>
        <P3 bold mb='8' color={color.colors.neutral900}>
          {t('success.payment_amount')}
        </P3>
        <SelectedUSDT>
          <div className='truncated'>
            <div>
              {selectedHub
                ? formatUSD(userPackage?.price + selected?.price)
                : formatUSD(licence?.price)}
            </div>
          </div>
          {/* <b>{USDT}</b> */}
        </SelectedUSDT>
      </div>

      <div style={{ marginBottom: 20 }}>
        <P3 bold mb='8' color={color.colors.neutral900}>
          {t('selected')} {t('success.network')}
        </P3>
        <SelectedUSDT>
          <div className='truncated'>
            <div>
              {selectedHub
                ? showNetworkType(userPackage)
                : showNetworkType(licence)}
            </div>
          </div>
        </SelectedUSDT>
      </div>

      <div style={{ marginBottom: 20 }}>
        <P3 bold mb='8' color={color.colors.neutral900}>
          Selected Token
        </P3>
        <SelectedUSDT>
          <div className='truncated'>
            <div>USDT / USDC</div>
          </div>
        </SelectedUSDT>
      </div>

      <P3 bold mb='8' color={color.colors.neutral900}>
        {t('success.wallet_address')}
      </P3>

      <SelectedUSDT
        onClick={() => {
          copyLink(
            selectedHub
              ? userPackage?.paymentAddress
              : licence?.paymentAddress || '',
            t('success.copied')
          );
        }}
        style={{ cursor: 'pointer' }}>
        <div className='truncated'>
          <div>
            {selectedHub
              ? userPackage?.paymentAddress
              : licence?.paymentAddress}
          </div>
        </div>

        <Icon ml='10' color={color.colors.neutral900}>
          <IconCopy />
        </Icon>
      </SelectedUSDT>

      <Button
        mt='40'
        onClick={() => {
          history.push(ORDERS);
        }}>
        {t('close')}
      </Button>
    </>
  );
};
